export default __webpack_public_path__ + "828a4d74a9d890f16694e7674671f3d4.png";